// Barthel Index 用API.

import axios, { AxiosInstance } from 'axios';
import { Dispatch } from 'redux';
import * as AWS from '../constants/AWS';
import * as BarthelIndexAPIConst from '../constants/BarthelIndexAPI';

/**
 * BarthelIndexAPIクラス.
 *
 * @export
 * @class BarthelIndexAPI
 */
export class BarthelIndexAPI {
  /** インスタンス */
  private static _instance: BarthelIndexAPI;
  private axiosInstance: AxiosInstance;

  /** インスタンスの取得 */
  public static get instance(): BarthelIndexAPI | null {
    // _inctanceが存在しない場合に、new MoffAPI()を実行する。
    if (!this._instance) {
      this._instance = new BarthelIndexAPI();
      
      // .envの設定 
      const API_BASE_URL = String(process.env.REACT_APP_BARTHEL_INDEX_API_URL);
      const API_KEY = String(process.env.REACT_APP_BARTHEL_INDEX_API_KEY);

      if (API_BASE_URL === 'undefined') {
        alert('.envにREACT_APP_BARTHEL_INDEX_API_URLの設定がありません.');
        return null;
      }

      if (API_KEY === 'undefined') {
        alert('.envにREACT_APP_BARTHEL_INDEX_API_KEYの設定がありません.');
        return null;
      }

      const userPool = AWS.userPool();
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser === null) {
        return null;
      }

      const self = this;
      cognitoUser.getSession(function(err: any, session: any) {
        if (err) {
          return;
        }

        if (session) {
          self._instance.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            headers: {
              'Authorization': session.getIdToken().getJwtToken(),
              'x-api-key': API_KEY
            }
          });
        }
      });
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }

  /**
   * BI測定データ取得.
   *
   * @param {string} uniqueId
   * @param {string} startDate
   * @param {string} endDate
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof BarthelAPI
   */
  public getBIRecords(
    uniqueId: string, startDate: string, endDate: string, requestFunc: Function, fetchedFunc: Function): any {
    const url = `/barthel/${uniqueId}/from/${startDate}/to/${endDate}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(BarthelIndexAPIConst.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          dispatch(fetchedFunc(BarthelIndexAPIConst.ERROR, error));
        });
    };
  }
}


// WEBPACK FOOTER //
// ./src/api/BarthelIndexAPI.tsx